export enum GLOBAL_SETTINGS_KEYS {
  STATUS_TRANSITIONS = "STATUS_TRANSITIONS",
  PUBLISHING_CREDENTIALS_CONFIRMATION = "PUBLISHING_CREDENTIALS_CONFIRMATION",
  DEFAULT_APP_USER_SETTINGS = "DEFAULT_APP_USER_SETTINGS",
  TEST_PLANS_INTEGRATION = "TEST_PLANS_INTEGRATION",
  TIMEOUTS = "TIMEOUTS",
  REPORT_TEMPLATE = "REPORT_TEMPLATE",
  DOCUMENTATION_TEMPLATE = "DOCUMENTATION_TEMPLATE",
  ADMINISTRATION_ADDRESS = "ADMINISTRATION_ADDRESS",
  REPORTS_LINK = "REPORTS_LINK",
  RESOLVERS_MODE = "RESOLVERS_MODE",
  POSITION_RESOLVER_META_SCORE_THRESHOLD = "POSITION_RESOLVER_META_SCORE_THRESHOLD",
  GENERATE_RESOLVERS_ON_PLAYBACK = "GENERATE_RESOLVERS_ON_PLAYBACK",
  MAILER_OPTIONS = "MAILER_OPTIONS",
  SSO_SAML_OPTIONS = "SSO_SAML_OPTIONS",
  SSO_AZURE_OPTIONS = "SSO_AZURE_OPTIONS",
  AI_OPTIONS = "AI_OPTIONS",
  SUMMARY_TEMPLATE = "SUMMARY_TEMPLATE",
}

export enum INTERNAL_SETTINGS_KEYS {
  DISABLED_FEATURES = "DISABLED_FEATURES",
  AUTO_SCREENSHOTS_CLEANUP = "AUTO_SCREENSHOTS_CLEANUP",
  HOTJAR = "HOTJAR",
}
export enum PUBLIC_SETTINGS_KEYS {
  RECAPTCHA_PUBLIC_KEY = "RECAPTCHA_PUBLIC_KEY",
  RECAPTCHA_ENABLED = "RECAPTCHA_ENABLED",
  SSO_AZURE_ENABLED = "SSO_AZURE_ENABLED",
  DISABLED_FEATURES = "DISABLED_FEATURES",
  SSO_SAML_ENABLED = "SSO_SAML_ENABLED",
}

export enum FEATURES {
  AUDIT_TRAIL = "AUDIT_TRAIL",
  GXP_TAGS = "GXP_TAGS",
  ELECTRONIC_SIGNOFF = "ELECTRONIC_SIGNOFF",
  SCRIPT_VERSIONING = "SCRIPT_VERSIONING",
  DOCUMENTATION = "DOCUMENTATION",
  REMOVABLE_DOCUMENTATION = "REMOVABLE_DOCUMENTATION",
  SUMMARY_REPORT = "SUMMARY_REPORT",
}

export enum InternalSettignsVisibility {
  ALL = "ALL",
  PUBLIC = "PUBLIC",
}

export enum ComparisonLogicalOperator {
  and = "and",
  or = "or",
}

export enum GlobalVariableType {
  CONSTANT = "Constant",
  MUTABLE = "Mutable",
}

export enum VariableDefaultValueType {
  Text = "Text",
  Number = "Number",
  Date = "Date",
}

// todo: finish types
export const ScriptStatus = {
  CLOSED: "CLOSED",
  PUBLISHED: "PUBLISHED",
  DRAFT: "DRAFT",
  IN_PROGRESS: "IN_PROGRESS",
  READY_TO_TEST: "READY_TO_TEST",
  READY_FOR_REVIEW: "READY_FOR_REVIEW",
} as const;

export enum ScriptStatusEnum {
  CLOSED = "CLOSED",
  PUBLISHED = "PUBLISHED",
  DRAFT = "DRAFT",
  IN_PROGRESS = "IN_PROGRESS",
  READY_TO_TEST = "READY_TO_TEST",
  READY_FOR_REVIEW = "READY_FOR_REVIEW",
}

export enum AssignedVariableType {
  LOCAL = "local",
  GLOBAL = "global",
}

export enum CodeType {
  CONSTANT = "CONSTANT",
  PICK = "PICK",
  EXPRESSION = "EXPRESSION",
  NATIVE = "NATIVE",
  ADVANCED = "ADVANCED",
  CODE_TEMPLATE = "CODE_TEMPLATE",
  AI_EXTRACT = "AI_EXTRACT",
}

export enum InputType {
  Date = "Date",
  Normal = "Normal",
}

export enum VariableGroups {
  SCRIPT = "Script",
  SCRIPTS = "Scripts",
  DATA_SOURCE = "DataSource",
  SEQUENCE = "Sequence",
  GLOBAL = "Global",
}

export enum CodeParamType {
  CONSTANT = "CONSTANT",
  VARIABLE = "VARIABLE",
}

export enum ImportMode {
  CLONE = "CLONE",
  EXPORT = "EXPORT",
}

export enum WorkItemSeverity {
  critical = "1 - Critical",
  high = "2 - High",
  medium = "3 - Medium",
  low = "4 - Low",
}

export enum IssueTrackingToolTrigger {
  ERROR = "ERROR",
  WARNING = "WARNING",
  INFO = "INFO",
  PLATFORM_ERROR = "PLATFORM ERROR",
  PLATFORM_WARNING = "PLATFORM WARNING",
}

export enum IssueTrackingToolConfigurationState {
  inactive = "inactive",
  active = "active",
  removed = "removed",
}

export enum AllowedWorkItemTypes {
  Bug = "Bug",
  Issue = "Issue",
  Task = "Task",
  TestCase = "Test Case",
}

export enum TestCaseState {
  Design = "Design",
  Ready = "Ready",
  Closed = "Closed",
}

export enum JOB_STATUS_TYPE {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  COMPLETED = "COMPLETED",
  CLOSED = "CLOSED",
  RUNNING = "RUNNING",
}

export enum TEST_RUN_STATE {
  UNSPECIFIED = "Unspecified",
  NOT_STARTED = "NotStarted",
  IN_PROGRESS = "InProgress",
  COMPLETED = "Completed",
  WAITING = "Waiting",
  ABORTED = "Aborted",
  QUEUED = "Queued",
}

export enum MESSAGE_TYPE {
  ERROR = "ERROR",
  WARNING = "WARNING",
  INFO = "INFO",
  ANALYSIS = "ANALYSIS",
}

export enum EXECUTION_STATUS {
  ERROR = "ERROR",
  WARNING = "WARNING",
  SUCCESS = "SUCCESS",
  NONE = "NONE",
  UNTESTED = "UNTESTED",
}

export enum SwitchMode {
  OFF = "Off",
  ON = "On",
}

export const TEST_RUN_OUTCOME_STATUS_MAP = {
  [EXECUTION_STATUS.ERROR]: "Failed",
  [EXECUTION_STATUS.SUCCESS]: "Passed",
  [EXECUTION_STATUS.WARNING]: "Warning",
};

export enum Commands {
  click = "click",
  focus = "focus",

  blur = "blur",
  menuItem = "menuItem",

  mousedown = "mousedown",
  keyup = "keyup",
  executeCode = "executeCode",
  password = "password",
  hotkey = "hotkey",
  assignValue = "assignValue",
  script = "script",
  change = "change",
  assert = "assert",

  check = "check",

  upload = "upload",
  start = "start",
  end = "end",
  login = "login",
  inspect = "inspect",

  veevaLookup = "veevaLookup",

  cposAuth = "cposAuth",
  CPOSCardHoverClick = "CPOSCardHoverClick",
  CPOSToggleClick = "CPOSToggleClick",
  CPOSDisassemblyKit = "CPOSDisassemblyKit",

  d365FSAdditionsSelectValue = "d365FSAdditionsSelectValue",
  d365FSMenu = "d365FSMenu",
  d365FSLookup = "d365FSLookup",

  dialogBox = "dialogBox",
  contextmenu = "contextmenu",
  lookup = "lookup",
  gridSelectRow = "gridSelectRow",
  gridSelectRow2 = "gridSelectRow2",
  selectSegmentEntry = "selectSegmentEntry",
  fastTabClick = "fastTabClick",

  beFashionExcel = "beFashionExcel", // temporary
  beFashionExcelEditStart = "beFashionExcelEditStart", // temporary
  beFashionExcelEditEnd = "beFashionExcelEditEnd", // temporary
  slider = "slider", // cpos slider filter
}

export enum CoreCommandsIds {
  aiAct = "aiAct",
  otp = "otp",
  start = "start",
  end = "end",
  script = "script", // A lot of internal code to handle connection between scripts
  inspect = "inspect", // We have a special UI for this command
  login = "login", // Player / Recorder need to detect login step
  condition = "condition",
  assign = "assign",
  click = "click",
  code = "code",
  type = "type",
  change = "change",
  upload = "upload",
  shortcut = "shortcut",
  clickWithFocus = "clickWithFocus",
  tokens = "tokens",
  mouseup = "mouseup",
  mousedown = "mousedown",
  password = "password",
  check = "check",
  hover = "hover",
}

export enum RunTypes {
  INSTANT = "INSTANT",
  NOTHING = "NOTHING",
  TIME = "TIME",
  DEPENDANT = "DEPENDANT",
}

export enum RepeaterTypes {
  SEQUENTIAL = "SEQUENTIAL",
  PARALLEL = "PARALLEL",
}

export enum EndTypes {
  NEVER = "NEVER",
  AFTER_OCCURENCES = "AFTER_OCCURENCES",
  ON_TIME = "ON_TIME",
}

export enum RecurrenceTypes {
  YEARS = "years",
  MONTHS = "months",
  WEEKS = "weeks",
  DAYS = "days",
  HOURS = "hours",
  MINUTES = "minutes",
}

export enum OverrideTypes {
  SINGLE = "SINGLE",
  POOL = "POOL",
}

export enum RunnerMode {
  RECORDER = "RECORDER",
  PLAYER = "PLAYER",
  COMBINED = "COMBINED",
}

export enum EXECUTION_STATE {
  NONE = "NONE",
  RUNNING = "RUNNING",
  PAUSED = "PAUSED",
  TERMINATED = "TERMINATED",
  FINISHED = "FINISHED",
}

export enum ScriptSpecialExecutionModes {
  DOCUMENT = "DOCUMENT",
  VIDEO = "VIDEO",
  DOC_AND_VIDEO = "DOC_AND_VIDEO",
}

export enum VariableParentType {
  TaskScript = "TaskScript",
  Sequence = "Sequence",
  Global = "Global",
}

export enum VariableType {
  Normal = "Normal",
  DataSource = "DataSource",
  Sequence = "Sequence",
}

export enum VariableValueType {
  Text = "Text",
  Number = "Number",
  Date = "Date",
}

export enum DOCUMENTATION_TYPE {
  VIDEO = "VIDEO",
  DOCUMENT = "DOCUMENT",
}

export enum ReportExtension {
  docx = "docx",
  pdf = "pdf",
}

export enum VIRTUAL_USER_STATUS {
  NOT_AUTHENTICATED = "NOT_AUTHENTICATED",
  AUTHENTICATED = "AUTHENTICATED",
  AUTHENTICATING = "AUTHENTICATING",
  ERROR = "ERROR",
}

export enum VIRTUAL_USER_AUTH_TYPE {
  NONE = "NONE",
  BASIC_AUTH = "BASIC_AUTH",
  NTLM = "NTLM",
  SYSTEM = "SYSTEM",
}

export enum EXECUTION_SCRIPT_TYPES {
  VIRTUAL_USER_AUTH = "VIRTUAL_USER_AUTH",
  SINGLE = "SINGLE",
}

export enum SaveVideoCondition {
  ON_ERROR = "ON_ERROR",
  ON_SUCCESS = "ON_SUCCESS",
  ALWAYS = "ALWAYS",
}

export enum StepTerminationType {
  TIMEOUT = "TIMEOUT",
  NUMBER_OF_EXECUTIONS = "NUMBER_OF_EXECUTIONS",
}

export enum StepTerminationAction {
  IGNORE_STEP = "IGNORE_STEP",
  TERMINATE_EXECUTION = "TERMINATE_EXECUTION",
}

export enum GlobalSettingsResolversModes {
  SMART = "SMART",
  LEGACY = "LEGACY",
  FALLBACK = "FALLBACK",
}

export enum DatasourceType {
  LOCAL = "LOCAL",
  GLOBAL = "GLOBAL",
}

export enum WebsocketMessageTypes {
  OPEN_CONNECTION = "OPEN_CONNECTION",
  NOTIFICATION = "NOTIFICATION",
  REMOVE_CLIENT_COOKIES = "REMOVE_CLIENT_COOKIES",
  SCHEDULER = "SCHEDULER",
  SUBSCRIBE_TO_UPDATES = "SUBSCRIBE_UPDATES",
  UNSUBSCRIBE_TO_UPDATES = "UNSUBSCRIBE_UPDATES",
  PERFORM_REFRESH = "PERFORM_REFRESH",
  HEARTBEAT = "HEARTBEAT",
  REPORT_GENERATION_START = "REPORT_GENERATION_START",
  REPORT_GENERATION_SUCCESS = "REPORT_GENERATION_SUCCESS",
  REPORT_GENERATION_FAIL = "REPORT_GENERATION_FAIL",
  EXPORT_GENERATION_START = "EXPORT_GENERATION_START",
  EXPORT_GENERATION_PROGRESS = "EXPORT_GENERATION_PROGRESS",
  EXPORT_GENERATION_FAIL = "EXPORT_GENERATION_FAIL",
  EXPORT_GENERATION_SUCCESS = "EXPORT_GENERATION_SUCCESS",
  GLOBAL_ACTIONS_SCREENSHOTS_CLEANUP_UPDATE = "GLOBAL_ACTIONS_SCREENSHOTS_CLEANUP_UPDATE",
}

export enum ExecutionTerminateTypes {
  SCRIPT = "SCRIPT",
  SCRIPT_FOREGROUND = "SCRIPT_FOREGROUND",
  SCHEDULER_RUN = "SCHEDULER_RUN",
  SCHEDULER = "SCHEDULER",
}

export enum DocumentationStatus {
  PUBLISHED = "PUBLISHED",
  DRAFT = "DRAFT",
  PENDING = "PENDING",
}

export enum ROLES {
  scheduler = "scheduler",
  reports = "reports",
  logs = "logs",
  settings = "settings",
  freedocs = "freedocs",
  admin = "admin",
  projects = "projects",
  documentationCreator = "documentation_creator",
  documentationReader = "documentation_reader",
}

export enum SYSTEM_TYPE {
  PROD = "production",
  DEV = "development",
  TEST = "test",
  UAT = "uat",
  OTHER = "other",
}

export const SYSTEM_TYPE_LABELS = {
  [SYSTEM_TYPE.PROD]: "Production",
  [SYSTEM_TYPE.DEV]: "Development",
  [SYSTEM_TYPE.TEST]: "Test",
  [SYSTEM_TYPE.UAT]: "User Acceptance Test",
  [SYSTEM_TYPE.OTHER]: "Other",
};

export enum PLAY_MODE {
  FOREGROUND = "foreground",
  BACKGROUND = "background",
}

export enum SSO {
  AzureActiveDirectory = "AzureActiveDirectory",
  SAML = "SAML",
}

export enum SupportedLanguages {
  PL = "PL",
  EN = "EN",
}

export enum IMPORT_SCRIPT_OPTIONS {
  USE_EXISTING = "use_existing",
  ALWAYS_CONVERT_DATASOURCE = "always_convert",
  ALWAYS_CLONE_DATASOURCE = "always_clone",
  CONVERT_DATASOURCE = "convert",
  CLONE_DATASOURCE = "clone",
}

export enum ScriptsCsvAdditionalFields {
  takeScreenshots = "takeScreenshots",
  screenshotsOnlyOnInterruption = "screenshotsOnlyOnInterruption",
  clickOnDisabledButtons = "clickOnDisabledButtons",
  useDefaultEnvironment = "useDefaultEnvironment",
  topProjectName = "topProjectName",
  virtualUserName = "virtualUserName",
}

export enum ScriptsSummaryReportAdditionalFields {
  scriptVersionNumber = "scriptVersionNumber",
  listOfSteps = "listOfSteps",
  averageDuration = "averageDuration",
  advancedConditional = "advancedConditional",
  summaryOfGlobalAndLocalVariables = "summaryOfGlobalAndLocalVariables",
  changelog = "changelog",
  linkedIn = "linkedIn",
}

export enum ScriptScreenshotsOptions {
  takeScreenshots = "takeScreenshots",
  screenshotsOnlyOnInterruption = "screenshotsOnlyOnInterruption",
  noScreenshots = "noScreenshots",
}

export enum AiRecoveryOptions {
  enabled = "enabled",
  enabledNoOptionalSteps = "enabledNoOptionalSteps",
  disabled = "disabled",
}

export enum ScriptAiRecoveryOptions {
  auto = "auto",
  enabled = "enabled",
  disabled = "disabled",
}

export enum StepAiRecoveryOptions {
  auto = "auto",
  enabled = "enabled",
  disabled = "disabled",
}

export enum BOOL_VALUE {
  TRUE = "true",
  FALSE = "false",
}

export enum SchedulerJobRunMode {
  PARALLEL = "PARALLEL",
  SEQUENTIAL = "SEQUENTIAL",
}

export enum PathType {
  XPATH = "XPATH",
  SELECTOR = "SELECTOR",
}

export enum Platform {
  D365FO = "D365FO",
  D365FS = "D365FS",
  TRANSPOREON = "TRANSPOREON",
  GOOGLE = "GOOGLE",
  STANDARD = "STANDARD",
  VEEVA = "VEEVA",
  MICROSOFT_LOGIN = "MICROSOFT_LOGIN",
  MICROSOFT_LOGIN_OKTA = "MICROSOFT_LOGIN_OKTA",
  OUTLOOK = "OUTLOOK",
  SAPUI = "SAPUI",
  OTHER = "OTHER",
  EP = "EP",
  DEFAULT_PLATFORM = "DEFAULT_PLATFORM",
  CLOUD_POS = "CLOUD_POS",
}

export enum ActivityAction {
  ifAction = "ifAction",
  elseAction = "elseAction",
}

export enum AssertionType {
  CHECK_VALUE = "CHECK_VALUE",
  DATA_SOURCE = "DATA_SOURCE",
}

export enum ConditionTypes {
  VARIABLE = "VARIABLE",
  STEP_VALUE = "STEP_VALUE",
  CONST = "CONST",
  GLOBAL_CONSTANT = "GLOBAL_CONSTANT",
  GLOBAL_MUTABLE = "GLOBAL_MUTABLE",
  EXPRESSION = "EXPRESSION",
  ADVANCED = "ADVANCED",
  NATIVE = "NATIVE",
}

export enum ComparisonsOperators {
  EQUAL = "EQUAL",
  NOT_EQUAL = "NOT_EQUAL",
  LESS = "LESS",
  LESS_OR_EQUAL = "LESS_OR_EQUAL",
  GREATER = "GREATER",
  GREATER_OR_EQUAL = "GREATER_OR_EQUAL",
  CONTAINS = "CONTAINS",
  NOT_CONTAINS = "NOT_CONTAINS",
  STARTS_WITH = "STARTS_WITH",
  ENDS_WITH = "ENDS_WITH",
}

export enum ComparisonsOperatorsSymbols {
  EQUAL = "=",
  NOT_EQUAL = "≠",
  LESS = "<",
  LESS_OR_EQUAL = "<=",
  GREATER = ">",
  GREATER_OR_EQUAL = ">=",
  CONTAINS = "[...]",
  NOT_CONTAINS = "[]...",
  STARTS_WITH = "|->",
  ENDS_WITH = "->|",
}

export enum AssertActions {
  JUMP = "JUMP",
  LOG = "LOG",
  WARNING = "WARNING",
  CONTINUE = "CONTINUE",
  ERROR = "ERROR",
  DATA_SOURCE_AND_JUMP = "DATA_SOURCE_AND_JUMP",
  REPEAT = "REPEAT",
  INCREASE_KPI = "INCREASE_KPI",
}

export enum CodeTemplateSaveMode {
  CURRENT = "CURRENT",
  AS_NEW_VERSION = "AS_NEW_VERSION",
  AS_NEW_ACTIVE_VERSION = "AS_NEW_ACTIVE_VERSION",
}

export enum CHECK_REFERENCE_TYPE {
  STEP_REFERENCE = "STEP_REFERENCE",
  VARIABLE_REFERENCE = "VARIABLE_REFERENCE",
  GLOBALVARIABLE_REFERENCE = "GLOBALVARIABLE_REFERENCE",
  DATASOURCE_REFERENCE = "DATASOURCE_REFERENCE",
  VIRTUAL_USER_REFERENCE = "VIRTUAL_USER_REFERENCE",
  SYSTEM_DEFINITION_REFERENCE = "SYSTEM_DEFINITION_REFERENCE",
}

export enum CONDITIONAL_TYPE {
  SUCCESS = "SUCCESS",
  INTERRUPTION = "INTERRUPTION",
}

export enum CONDITIONAL_ACTION_TYPE {
  SIMPLE = "SIMPLE",
  ADVANCED = "ADVANCED",
}

export enum INTERRUPTION_TYPE {
  SYSTEM_ERROR = "SYSTEM_ERROR",
  SYSTEM_WARNING = "SYSTEM_WARNING",
  ELEMENT_NOT_FOUND = "ELEMENT_NOT_FOUND",
  ERROR = "ERROR",
  WARNING = "WARNING",
}

export enum DataSourceComparisonType {
  HAS_NEXT = "HAS_NEXT",
}

export enum EA_ERROR_CODES {
  USER_INVALID_CREDENTIALS = "1001",
  USER_MULTI_SESSSION_BLOCK = "1002",
  USER_ACCOUNT_IS_INACTIVE = "1003",
}

export enum ExportToCsvModels {
  SCRIPTS = "TaskScript",
  LOGS = "ExecutionLog",
  STEP_LOGS = "ExecutionStepLog",
  EXECUTION_JOB_LOGS = "ExecutionJobLog",
  SCHEDULER_FLOW = "SchedulerJobMapping",
}

export enum REAUTH_INTERVAL_TYPE {
  HOUR = "HOUR",
  DAY = "DAY",
  WEEK = "WEEK",
}

export enum FileConverterOutputExtension {
  PDF = "pdf",
  XLSX = "xlsx",
}

export enum JOB_TRIGGER_TYPE {
  INSTANT = "instant",
  TIME = "time",
  STORAGE = "storage",
}

export enum ExecuteEntityType {
  SCRIPT = "script",
  JOB = "job",
  PROJECT = "project",
}

export enum SchedulerMode {
  BASIC = "BASIC",
  GANTT = "GANTT",
}

export enum ApplicationVariant {
  AB = "AB",
  EA = "EA",
}

export enum EndType {
  afterOccurrences = "afterOccurrences",
  onDate = "onDate",
  never = "never",
}

export enum RecurrenceType {
  minutes = "minutes",
  hours = "hours",
  days = "days",
  weeks = "weeks",
  months = "months",
  years = "years",
}

export enum RecurrenceTypeSingular {
  minutes = "minute",
  hours = "hour",
  days = "day",
  weeks = "week",
  months = "month",
  years = "year",
}

export enum TimeScheluderLabel {
  once = "once",
  times = "times",
}

export enum ErrorCodes {
  STARTING_SESSION = "STARTING_SESSION",
  SESSIONS_LIMIT_REACHED = "SESSIONS_LIMIT_REACHED",
  MISSING_COMMAND = "MISSING_COMMAND",
  MISSING_FRAME_OBJECT = "MISSING_FRAME_OBJECT",
  FRAME_NOT_FOUND = "FRAME_NOT_FOUND",
  PAGE_CONTEXT_NOT_FOUND = "PAGE_CONTEXT_NOT_FOUND",
  AUTH_NOT_SUPPORTED_IN_FRAME = "AUTH_NOT_SUPPORTED_IN_FRAME",
  MISSING_AI_EXTRACTION_INSTRUCTION = "MISSING_AI_EXTRACTION_INSTRUCTION",
  AI_EXTRACTION_FAILED = "AI_EXTRACTION_FAILED",
  MISSING_FRAME_COMMANDS = "MISSING_FRAME_COMMANDS",
  MISSING_STEP_RESOLVERS = "MISSING_STEP_RESOLVERS",
  INVALID_ASSERTION_OPERATOR = "INVALID_ASSERTION_OPERATOR",
  INVALID_STEP_VALUE_CONDITION = "INVALID_STEP_VALUE_CONDITION",
  ASSERTION_STEP_NOT_FOUND = "ASSERTION_STEP_NOT_FOUND",
  UNSUPPORTED_STRING_CONDITION_VALUE = "UNSUPPORTED_STRING_CONDITION_VALUE",
  CONDITION_VARIABLE_NOT_FOUND = "CONDITION_VARIABLE_NOT_FOUND",
  UNSUPPORTED_CONDITION_TYPE = "UNSUPPORTED_CONDITION_TYPE",
  AI_EXTRACT_DATA_NOT_FOUND = "AI_EXTRACT_DATA_NOT_FOUND",
  AI_OBSERVE_RESULTS_NOT_FOUND = "AI_OBSERVE_RESULTS_NOT_FOUND",
  AI_OPERATOR_RESPONSE_INVALID = "AI_OPERATOR_RESPONSE_INVALID",
  AI_OPERATOR_UNKNOWN_ACTION = "AI_OPERATOR_UNKNOWN_ACTION",
  AI_RECOVERY_FAILED = "AI_RECOVERY_FAILED",
  AI_RECOVERY_INCOMPLETE = "AI_RECOVERY_INCOMPLETE",
  AI_RECOVERY_DATA_ABORTED = "AI_RECOVERY_DATA_ABORTED",
  AI_RECOVERY_DATA_FAILED = "AI_RECOVERY_DATA_FAILED",
  SCRIPT_STEPS_NOT_FOUND = "SCRIPT_STEPS_NOT_FOUND",
  RECOVERY_STEP_NOT_FOUND = "RECOVERY_STEP_NOT_FOUND",
  VARIABLE_TO_OVERRIDE_NOT_FOUND = "VARIABLE_TO_OVERRIDE_NOT_FOUND",
  ELEMENT_NOT_FOUND = "ELEMENT_NOT_FOUND",
  ELEMENT_VALIDATION_FAILED = "ELEMENT_VALIDATION_FAILED",
  TAB_CLOSED = "TAB_CLOSED",
  SCRIPT_EXPIRED = "SCRIPT_EXPIRED",
}

export enum LicenseType {
  FREEMIUM = "Freemium",
  BASIC = "Basic",
  REGULAR = "Regular",
  ENTERPRISE = "Enterprise",
  PAY_PER_USE = "Pay per use",
}

export enum STATUS_TYPE {
  ERROR = "ERROR",
  WARNING = "WARNING",
  SUCCESS = "SUCCESS",
  RUNNING = "RUNNING",
  TERMINATED = "TERMINATED",
  NONE = "NONE",
  UNTESTED = "UNTESTED",
  // TODO: \/ to remove, mark execution as background
  RUNNING_IN_BACKGROUND = "RUNNING IN BACKGROUND",
}

export enum SubscribeUpdateModelNames {
  TASK_STEP = "TaskStep",
  VARIABLE = "Variable",
}

export enum LicenseErrors {
  readingFile = "Error while reading licence file",
  decryptError = "Error while decrypting license file",
  invalidLicenseNumber = "Invalid license number",
}

export enum LogCsvAdditionalFields {
  scriptLogUrl = "scriptLogUrl",
  schedulerJobName = "schedulerJobName",
  jobId = "jobId",
  lastErrorMessage = "lastErrorMessage",
}

export enum SchedulerRunTypes {
  TIME = "TIME",
  DEPENDANT = "DEPENDANT",
  INSTANT = "INSTANT",
}

export enum TEMPLATE_TYPE {
  REPORT_TEMPLATE = "reportTemplate",
  DOCUMENTATION_TEMPLATE = "documentationTemplate",
  SUMMARY_TEMPLATE = "summaryTemplate",
}

export enum PredefinedVariable {
  CurrentStepValue = "CurrentStepValue",
}

export enum Extension {
  XLSX = ".xlsx",
}

export const SPECIAL_KEY_CODES = {
  ENTER: 13,
  SPACE: 32,
  G: 71,
  D: 68,
  H: 72,
  L: 76,
  Q: 81,
  M: 77,
  N: 78,
  S: 83,
  DEL: 68,
  F9: 120,
  F5: 116,
  F2: 113,
  E: 69,
  F: 70,
  A: 65,
  ARROW_DOWN: 40,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_LEFT: 37,
  TAB: 9,
  HOME: 36,
  END: 35,
  ESC: 27,
} as const;

export enum BoolValue {
  TRUE = "true",
  FALSE = "false",
  NOT_DEFINED = "not_defined",
}

export enum ResolverType {
  XPATH = "XPATH",
  SELECTOR = "SELECTOR",
  SMART_XPATH_SEGMENTS = "SMART_XPATH_SEGMENTS",
  POSITION = "POSITION",
}
